import { Modal } from 'antd';
import { Button } from '../button';
import ExclamationCircle from '../../icons/ExclamationCircle.svg?react';
import style from './style.module.scss';

type UnsavedChangesModalProps = {
    onSave: () => void;
    onDiscard: () => void;
    onClose: () => void;
    isSaving: boolean;
    saveDisabled: boolean;
};

export const UnsavedChangesModal = ({
    onSave,
    onDiscard,
    onClose,
    isSaving,
    saveDisabled,
}: UnsavedChangesModalProps) => {
    return (
        <Modal
            open={true}
            onCancel={onClose}
            cancelText={null}
            footer={null}
            centered
            width={464}
            maskClosable={true}
            maskStyle={{
                backgroundColor: 'rgba(242,242,242,0.8)',
            }}
            className={style.modal}
        >
            <div className={style.modal_content}>
                <div className={style.icon}>
                    <ExclamationCircle width={18} height={18} />
                </div>
                <div className={style.modal_text_content}>
                    <h5 className={style.title}>
                        Save changes before closing?
                    </h5>
                    <div className={style.text}>
                        You have unsaved changes. If you do not save, these
                        changes will be lost.
                    </div>
                </div>
            </div>
            <div className={style.button_container}>
                <Button
                    variant="secondary"
                    onClick={onDiscard}
                    disabled={isSaving}
                >
                    Cancel changes
                </Button>
                <Button
                    variant="primary"
                    onClick={onSave}
                    loading={isSaving}
                    disabled={saveDisabled}
                >
                    Save changes
                </Button>
            </div>
        </Modal>
    );
};
